import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { store } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'RadioButton',
  props: {
    name: null,
    text: null,
    disabled: { type: Boolean },
    value: null,
    checkValue: null,
    customStyling: null,
    error: null
  },
  emits: ["input", "onSelect"],
  setup(__props: any, { emit }: { emit: ({(e: 'input', value: any): void,
    (e: 'onSelect', value: any): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    name: string,
    text?: string,
    disabled?: boolean,
    value?: string,
    checkValue?: string,
    customStyling?: any,
    error?: string
}






const textColor = computed<OpacityFunction>(() => store.getters['app/textColor']);
function updateValue(event) {           
    emit('input', event.target.value);
    emit('onSelect', event.target.value);
}


return { __sfc: true,props, emit, textColor, updateValue }
}

})